module.exports = __webpack_public_path__ + "static/media/kolorowanka_3.1502a3c4.png";